import { useCallback } from 'react';
import { analyticsTrackEvent } from '../../../../../core/analytics';
import { Actions, Events } from '../../../../Account/util/analytics';
import history from '../../../../../core/history';
import { isActiveMembership } from '../../../../../core/util/account';
import { redirectToStripeBillingPortal } from '../../../../../core/dapi/membership';
import { BASE_URL } from '../../../../../config';

export const useGoToMembership = (onClose: any, accountSummary: any, returnUrl: string) => {
  return useCallback(() => {
    onClose();
    analyticsTrackEvent(Events.ACCOUNT_NAVIGATION, {
      action: Actions.CLICK_MEMBERSHIP_AND_BILLING,
      label: 'Touch Membership and Billing',
    });
    if (isActiveMembership(accountSummary)) {
      redirectToStripeBillingPortal(BASE_URL + returnUrl);
    } else {
      history.push('/membership');
    }
  }, [accountSummary, onClose, returnUrl]);
};
